export default "__VITE_ASSET__DZ3ZxD0y__"